<template>
	<div class="login-container">
		<div class="login-content">
			<!-- Logo -->
			<div class="logo-wrapper">
				<img src="../assets/logo-sc-blanco.svg" alt="Logo" class="logo-img" />
			</div>

			<!-- Login Card -->
			<div class="login-card">
				<h1 class="login-title">{{ $t('login.txtWelcome') || 'Bienvenido' }}</h1>
				<p class="login-subtitle">{{ $t('login.txtSubtitle') || 'Ingresa tus credenciales' }}</p>

				<v-form v-model="valid" ref="form" class="login-form">
					<div class="input-group">
						<label class="input-label">{{ $t('global.email') }}</label>
						<v-text-field
							v-model="email"
							:rules="emailRules"
							:placeholder="$t('login.emailPlaceholder') || 'tu@email.com'"
							required
							outlined
							dense
							hide-details="auto"
							autocomplete="username"
							class="modern-input"
						></v-text-field>
					</div>

					<div class="input-group">
						<label class="input-label">{{ $t('global.password') }}</label>
						<v-text-field
							v-model="password"
							:type="showPassword ? 'text' : 'password'"
							:rules="passwordRules"
							:placeholder="$t('login.passwordPlaceholder') || '••••••••'"
							required
							outlined
							dense
							hide-details="auto"
							autocomplete="current-password"
							class="modern-input"
							@keyup.enter="submit"
						>
							<template v-slot:append>
								<v-icon
									size="20"
									color="#999"
									@click="showPassword = !showPassword"
									style="cursor: pointer;"
								>
									{{ showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
								</v-icon>
							</template>
						</v-text-field>
					</div>

					<button
						type="button"
						class="login-btn"
						:class="{ 'btn-disabled': !valid || disabled }"
						:disabled="!valid || disabled"
						@click="submit"
					>
						<v-progress-circular
							v-if="loading"
							indeterminate
							color="white"
							size="20"
							width="2"
							class="mr-2"
						></v-progress-circular>
						{{ $t('login.btnLogin') }}
					</button>

					<button
						type="button"
						class="forgot-btn"
						@click.prevent="forgot"
					>
						{{ $t('login.forgotPassword') }}
					</button>
				</v-form>
			</div>
		</div>

		<!-- Snackbar -->
		<v-snackbar v-model="snackbar" color="#333" rounded="pill" timeout="3000">
			{{ text }}
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="snackbar = false" small>
					{{ $t('global.snackbar.close') }}
				</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { auth } from "../plugins/firebase";
export default {
	data() {
		return {
			valid: false,
			showPassword: false,
			snackbar: false,
			text: "",
			password: "",
			passwordRules: [(v) => !!v || this.$t('global.rules.passwordRequired')],
			email: "",
			emailRules: [
				(v) => !!v || this.$t('global.rules.emailRequired'),
			],
			loading: false,
			disabled: false,
			deferredPrompt: null
		};
	},
	computed: {
	},
	methods: {
		submit(e) {
			e.preventDefault();
			this.loading = true;
			this.disabled = true;
			this.$axios
				.post("/auth/login", {
					email: this.email,
					password: this.password,
				})
				.then((resp) => {
					// Save token
					this.setUserToken(resp.data.access_token);
					// User data
					this.$axios
						.post("/auth/me")
						.then((res) => {
							this.setUserData(res.data);
							// Asignar el lenguaje
							this.$root.$i18n.locale = res.data.lang;
							this.setLang(res.data.lang);
							// Recuperar datos del chat
							this.authChat(res.data.userChatToken)
								.then(() => {
									if (res.data.currentTransportUnit === null) {
										this.$router.push({ name: "SelectUnit" });
									} else {
										this.$router.push({ name: "Home" });
									}
								})
								.catch(() => {
									throw new Error("Error firebase");
								});
						})
						.catch(() => {
							this.text = this.$t('login.txtErrorRetrievingUserData');
							this.snackbar = true;
							this.showSnackBar();
						});
				})
				.catch(() => {
					this.text = this.$t('login.txtEmailPasswordInvalid');
					this.snackbar = true;
					this.showSnackBar();
					this.loading = false;
					this.disabled = false;
				});
		},
		showSnackBar() {
			setTimeout(() => {
				this.snackbar = false;
			}, 2000);
		},
		clear() {
			this.$refs.form.reset();
		},
		forgot() {
			this.$router.push({ name: "Forgot" });
		},
		authChat(token) {
			return auth.signInWithCustomToken(token);
		},
		...mapMutations({setLang: 'setLang'}),
		...mapMutations("auth", {
			setUserToken: "setUserToken",
			setUserData: "setUserData",
		}),
		...mapGetters("auth", { isLogin: "isLogin" }),
		
	},
	mounted() {
		if (this.isLogin()) {
			this.$router.push({ name: "Home" });
		}
	},
};
</script>

<style scoped>
.login-container {
	min-height: 100vh;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.login-content {
	width: 100%;
	max-width: 360px;
}

.logo-wrapper {
	text-align: center;
	margin-bottom: 28px;
}

.logo-img {
	max-width: 200px;
	height: auto;
}

.login-card {
	background: #fff;
	border-radius: 16px;
	padding: 28px 24px;
}

.login-title {
	font-size: 22px;
	font-weight: 600;
	color: #1a1a1a;
	margin: 0 0 4px;
	text-align: center;
}

.login-subtitle {
	font-size: 14px;
	color: #888;
	margin: 0 0 24px;
	text-align: center;
}

.login-form {
	display: flex;
	flex-direction: column;
}

.input-group {
	margin-bottom: 16px;
}

.input-label {
	display: block;
	font-size: 13px;
	font-weight: 500;
	color: #555;
	margin-bottom: 6px;
}

.modern-input >>> .v-input__slot {
	border-radius: 10px !important;
	min-height: 46px !important;
}

.modern-input >>> .v-text-field__slot input {
	font-size: 14px;
}

.login-btn {
	width: 100%;
	padding: 14px;
	border: none;
	border-radius: 10px;
	background: #6200ea;
	color: #fff;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 8px;
}

.login-btn:active {
	transform: scale(0.98);
	background: #5000d0;
}

.btn-disabled {
	background: #ccc;
	cursor: not-allowed;
}

.btn-disabled:active {
	transform: none;
	background: #ccc;
}

.forgot-btn {
	width: 100%;
	padding: 12px;
	border: none;
	background: transparent;
	color: #6200ea;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.15s ease;
	margin-top: 8px;
}

.forgot-btn:active {
	opacity: 0.7;
}
</style>
